import React, { useState, useEffect } from 'react';
import './Preferences.css';

const PREF_KEY_AUTOCOMPLETE = 'cloudfish_autocomplete_enabled';
const PREF_KEY_DARK_THEME = 'cloudfish_dark_theme';

export function getAutocompleteEnabled() {
  try {
    const stored = localStorage.getItem(PREF_KEY_AUTOCOMPLETE);
    if (stored === null) return false; // default off
    return stored === 'true';
  } catch {
    return false;
  }
}

export function setAutocompleteEnabled(value) {
  try {
    localStorage.setItem(PREF_KEY_AUTOCOMPLETE, String(!!value));
  } catch (e) {
    console.warn('Failed to save autocomplete preference:', e);
  }
}

export function getDarkThemeEnabled() {
  try {
    const stored = localStorage.getItem(PREF_KEY_DARK_THEME);
    if (stored === null) return false;
    return stored === 'true';
  } catch {
    return false;
  }
}

export function setDarkThemeEnabled(value) {
  try {
    localStorage.setItem(PREF_KEY_DARK_THEME, String(!!value));
    document.documentElement.classList.toggle('dark-theme', !!value);
  } catch (e) {
    console.warn('Failed to save dark theme preference:', e);
  }
}

const Preferences = ({ isOpen, onClose, autocompleteEnabled, onAutocompleteChange }) => {
  const [autocomplete, setAutocomplete] = useState(autocompleteEnabled);
  const [darkTheme, setDarkTheme] = useState(() => getDarkThemeEnabled());

  useEffect(() => {
    setAutocomplete(autocompleteEnabled);
  }, [autocompleteEnabled]);

  useEffect(() => {
    setDarkTheme(getDarkThemeEnabled());
  }, [isOpen]);

  const handleAutocompleteToggle = (checked) => {
    setAutocomplete(checked);
    setAutocompleteEnabled(checked);
    onAutocompleteChange?.(checked);
  };

  const handleDarkThemeToggle = (checked) => {
    setDarkTheme(checked);
    setDarkThemeEnabled(checked);
  };

  if (!isOpen) return null;

  return (
    <div className="preferences-overlay" onClick={onClose}>
      <div className="preferences-modal" onClick={e => e.stopPropagation()}>
        <div className="preferences-header">
          <h2>Preferences</h2>
          <button type="button" className="preferences-close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="preferences-body">
          <div className="preference-item">
            <label className="preference-label">
              <input
                type="checkbox"
                checked={autocomplete}
                onChange={e => handleAutocompleteToggle(e.target.checked)}
              />
              <span>SQL Autocomplete</span>
            </label>
            <p className="preference-description">Show suggestions for SQL keywords, functions, tables, and packages as you type.</p>
          </div>
          <div className="preference-item">
            <label className="preference-label">
              <input
                type="checkbox"
                checked={darkTheme}
                onChange={e => handleDarkThemeToggle(e.target.checked)}
              />
              <span>Dark theme</span>
            </label>
            <p className="preference-description">Use a dark color scheme throughout the app for reduced eye strain.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
